<template>
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="end" class="my-4 ml-1">
        <v-col>
          <a>
            <span class="display-1 titulo font-weight-bold" @click="getDocumentos()">Documentos</span>
          </a>
        </v-col>
        <v-spacer></v-spacer>
        <v-col md="auto" cols="auto" sm="auto" v-if="sub_pasta.length > 0">
          <v-btn rounded color="#283480" @click="voltar()" class="white--text">Voltar</v-btn>
        </v-col>
        <v-col md="auto" cols="auto" sm="auto" v-if="!meus_documentos">
          <v-btn rounded color="#283480" @click="dialog_novo = true" class="white--text">Novo</v-btn>
        </v-col>
      </v-row>

      <!-- BREADCRUMBS -->
      <v-row class="pa-0 ma-0 mt-n4 ml-5">
        <v-col class="pa-0 ma-0">
          <span
            class="title mr-3 font-weight-light"
            v-for="(item,index) in sub_pasta"
            :key="index"
          >> {{ item.documento_pasta_nome }}</span>
        </v-col>
      </v-row>

      <!-- Pastas -->

      <v-card
        v-if="documentos_api.length > 0"
        flat
        height="100%"
        class="borda"
        :disabled="loading_doc"
      >
        <v-container fluid>
          <v-row>
            <v-col
              class="mb-n4"
              cols="12"
              sm="6"
              md="4"
              v-for="(item, index) in pastas"
              :key="index"
            >
              <v-card
                flat
                outlined
                class="borda"
                width="100%"
                :disabled="loading_doc"
                @click="entrar_pasta(item)"
              >
                <v-card-text class="py-1">
                  <v-row>
                    <v-icon class="pl-3">mdi-folder-outline</v-icon>
                    <span class="subtitle-2 mt-2">⠀{{ item.documento_pasta_nome }}</span>
                    <v-spacer></v-spacer>
                    <v-tooltip color="black" top v-if="meus_documentos">
                      <template v-slot:activator="{ on }">
                        <v-btn icon class="mr-1" v-on="on">
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Sem autorização para
                        <span class="orange--text">editar</span> ou
                        <span class="red--text">excluir</span>
                      </span>
                    </v-tooltip>
                    <v-menu offset-x v-if="!meus_documentos">
                      <template v-slot:activator="{ on }">
                        <v-btn icon text v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <!-- <div v-for="(iten, index) in opcoes" :key="index">
                          <v-list-item @click="menu(iten, item)">
                            <v-icon>{{ iten.icon }}</v-icon>
                            <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                          </v-list-item>
                        </div>-->
                        <v-list-item
                          @click="menu('Alterar acessos', item)"
                          v-if="item.usuario_token == user_token"
                        >
                          <v-icon>mdi-shield-account-outline</v-icon>
                          <v-list-item-title>⠀Alterar acessos</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="menu('Remover', item)"
                          v-if="item.usuario_token == user_token"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                          <v-list-item-title>⠀Remover</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="menu('Detalhes', item)">
                          <v-icon>mdi-information-outline</v-icon>
                          <v-list-item-title>⠀Detalhes</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="pastas.length > 0 && arquivos.length > 0">
            <v-divider class="mx-4 mt-5"></v-divider>
          </v-row>

          <!-- arquivos -->
          <v-row class="mt-3">
            <v-col cols="12" sm="6" md="3" v-for="(item, index) in arquivos" :key="index">
              <v-card flat outlined class="borda" :disabled="loading_doc" @click="embed(item)">
                <v-card-title class="pa-0">
                  <div class="ml-3">
                    <v-icon>mdi-file</v-icon>
                  </div>
                  <v-spacer></v-spacer>
                  <v-tooltip color="black" top v-if="meus_documentos">
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mr-1" v-on="on">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span> ou
                      <span class="red--text">excluir</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="!meus_documentos">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <!-- <div v-for="(iten, index) in opcoes" :key="index">
                        <v-list-item @click="menu(iten, item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>-->
                      <v-list-item
                        @click="menu('Alterar acessos', item)"
                        v-if="item.usuario_token == user_token"
                      >
                        <v-icon>mdi-shield-account-outline</v-icon>
                        <v-list-item-title>⠀Alterar acessos</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="menu('Remover', item)"
                        v-if="item.usuario_token == user_token"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                        <v-list-item-title>⠀Remover</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="menu('Detalhes', item)">
                        <v-icon>mdi-information-outline</v-icon>
                        <v-list-item-title>⠀Detalhes</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>
                <v-card-text style="white-space: nowrap !important;">
                  <v-tooltip color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="subtitle-2 ml-n3"
                        v-on="on"
                        v-bind="attrs"
                      >⠀{{item.documento_pasta_nome}}</span>
                    </template>
                    <span>
                      <span class="subtitle-2 ml-n3">⠀{{item.documento_pasta_nome}}</span>
                    </span>
                  </v-tooltip>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card flat v-else height="100%" :loading="loading_doc" class="borda ma-3">
        <v-row justify="center" no-gutters>
          <span
            class="title text--secondary mx-2 my-5"
            v-if="!loading_doc"
          >Nenhum documento ou pasta encontrada</span>
        </v-row>
      </v-card>
      <!-- DIALOG INFO -->
      <v-dialog v-model="dialog_detalhes" max-width="650">
        <v-card class="borda" flat>
          <v-card-title>
            <div class="ml-1">
              <v-icon large>mdi-file</v-icon>
            </div>
            <span class="headline ma-3">{{ detalhes.documento_pasta_nome }}</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-2">
            <v-container class="ml-3">
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Tipo:</span>
                <span class="subtitle-1 black--text">{{ detalhes.documento_pasta_type }}</span>
              </v-row>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Tamanho:</span>
                <span class="subtitle-1 black--text">{{ detalhes.documento_pasta_size }} Kb</span>
              </v-row>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Propietário:</span>
                <span class="subtitle-1 black--text">{{ detalhes.usuario_nome }}</span>
              </v-row>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Criado em:</span>
                <span class="subtitle-1 black--text">{{ detalhes.created_at | moment("L") }}</span>
              </v-row>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Link:</span>
                <v-col class="ma-0 pa-0">
                  <span
                    class="black--text"
                  >{{ this.URLpadrao + `/meu_titulo/show?documento_pasta_hash=` + detalhes.documento_pasta_hash }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG INFO FOLDER -->
      <v-dialog v-model="dialog_detalhes_Pasta" max-width="650">
        <v-card class="borda" flat>
          <v-card-title>
            <div class="ml-1">
              <v-icon large>mdi-folder-outline</v-icon>
            </div>
            <span class="headline ma-3">{{ detalhes.documento_pasta_nome }}</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="dialog_detalhes_Pasta = false">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-2">
            <v-container class="ml-3">
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Propietário:</span>
                <span class="subtitle-1 black--text">{{ detalhes.usuario_nome }}</span>
              </v-row>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text mr-2">Criado em:</span>
                <span class="subtitle-1 black--text">{{ detalhes.created_at | moment("L") }}</span>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG ACESSO -->
      <v-dialog v-model="dialog_acesso" max-width="650">
        <v-card class="borda" flat>
          <v-card-title>
            <div class="ml-1">
              <v-icon large color="blue darken-3" v-if="folder_file_selected.arquivo">mdi-file</v-icon>
              <v-icon large color="blue darken-3" v-else>mdi-folder</v-icon>
            </div>
            <span class="headline ma-3">{{folder_file_selected.documento_pasta_nome}}</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-2">
            <v-container>
              <v-row class="my-1">
                <span class="subtitle-1 font-weight-bold black--text">Link:⠀</span>
                <span class="subtitle-1 black--text"></span>
              </v-row>
              <v-row class="my-1">
                <span class="title font-weight-bold black--text">Quem pode acessar?</span>
              </v-row>
              <v-autocomplete
                :items="select_acessos"
                item-value="nome"
                item-text="nome"
                solo
                flat
                color="#283480"
                outlined
                multiple
                dense
                v-model="acessos_selecionados"
                :return-object="true"
                chips
                small-chips
                deletable-chips
                @change="changeAcessos()"
                no-data-text="Nenhum grupo autorizado"
              ></v-autocomplete>
              <v-row class="my-1">
                <span>Digite o e-mail do associado e pressione ENTER para liberar acesso</span>
              </v-row>
              <v-row class="my-1">
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    full-width
                    solo
                    dense
                    flat
                    outlined
                    label="Digite aqui..."
                    single-line
                    hide-details
                    v-on:keyup.enter="addEmail(email)"
                  ></v-text-field>
                </v-col>
                <v-col v-for="(e, index) in emails_selecionados" :key="index" class="shrink">
                  <v-chip close @click:close="emails_selecionados.splice(index, 1)">{{ e.email }}</v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mt-n10">
            <v-row class="mb-7" no-gutters justify="center">
              <v-btn rounded color="#283480" class="mr-2" outlined @click="close()">Cancelar</v-btn>
              <v-btn
                class="ml-2"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                rounded
                :disabled="loadingSaveAcessos"
                @click="saveAcessos()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG EXCLUSÃO -->
      <v-dialog v-model="dialog_remover" persistent max-width="400">
        <v-card class="borda" flat>
          <v-card-title class="headline">Tem certeza que deseja deletar este item?</v-card-title>
          <v-card-text>Se deletar este item ele não poderá ser recuperado!!</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined rounded color="#283480" @click="close()">Cancelar</v-btn>
            <v-btn
              style="background-color: #283480  !important; color:#00FFD4  !important"
              rounded
              @click="deleteItem()"
            >Sim, tenho certeza</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG NOVO -->
      <v-dialog v-model="dialog_novo" max-width="500" transition="dialog-transition">
        <v-card flat class="borda pb-4">
          <v-card-title>
            <span class="headline" v-if="nova_pasta">Nova pasta</span>
            <span class="headline" v-else-if="novo_arquivo">Novo arquivo</span>
            <span class="headline" v-else>Novo documento</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="reset_novo()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-5">
            <div v-if="!nova_pasta">
              <div v-if="!novo_arquivo">
                <v-row no-gutters justify="center">
                  <v-btn
                    rounded
                    color="#283480"
                    class="white--text mr-2"
                    @click="nova_pasta = true"
                  >Nova pasta</v-btn>
                  <v-btn
                    rounded
                    color="#283480"
                    class="white--text ml-2"
                    @click="novo_arquivo = true"
                  >Novo Arquivo</v-btn>
                </v-row>
              </div>
            </div>
            <div v-if="nova_pasta">
              <v-row>
                <v-col>
                  <span class="font-weight-bold black--text">Nome da pasta</span>
                  <v-text-field v-model="nova_pasta1.documento_pasta_nome" solo flat outlined dense></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div v-if="novo_arquivo">
              <v-row>
                <v-col>
                  <span class="font-weight-bold black--text">Selecione os documentos</span>
                  <v-file-input
                    show-size
                    prepend-icon="mdi-rotate-45 mdi-paperclip"
                    solo
                    multiple
                    v-model="novo_documento.documentos"
                    outlined
                    flat
                    dense
                  ></v-file-input>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions class="mt-n8">
            <div v-if="nova_pasta">
              <v-row no-gutters justify="end">
                <v-btn rounded color="#283480" class="mr-2" @click="reset_novo()" outlined>Cancelar</v-btn>
                <v-btn
                  rounded
                  color="#283480"
                  :disabled="loading_pasta"
                  :loading="loading_pasta"
                  class="white--text ml-2"
                  @click="sendPasta()"
                >Salvar</v-btn>
              </v-row>
            </div>
            <div v-if="novo_arquivo">
              <v-row no-gutters justify="center">
                <v-btn rounded color="#283480" class="mr-2" @click="reset_novo()" outlined>Cancelar</v-btn>
                <v-btn
                  rounded
                  color="#283480"
                  :disabled="loading_pasta"
                  class="white--text ml-2"
                  @click="sendArquivo()"
                >Salvar</v-btn>
              </v-row>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-overlay :value="loading_doc">
      <v-container fluid fill-height>
        <v-progress-circular color="#283480" indeterminate size="80"></v-progress-circular>
      </v-container>
      <v-container fluid fill-height>
        <span style="color:#283480 !important;" class="mr-12 ml-n7">Criando documento...</span>
      </v-container>
    </v-overlay>
    <v-overlay :value="loading_pasta">
      <v-container fluid fill-height>
        <v-progress-circular color="#283480" indeterminate size="80"></v-progress-circular>
      </v-container>
    </v-overlay>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      loading_doc: false,
      novo_documento: {
        documentos: [],
        pasta_raiz: null
      },
      select_acessos: [],
      nova_pasta1: {
        documento_pasta_nome: "",
        pasta_raiz: null
      },
      nova_pasta: false,
      novo_arquivo: false,
      permissao: [],
      email: [],
      emails: [],
      opcoes: [
        { nome: "Alterar acessos", icon: "mdi-shield-account-outline" },
        { nome: "Remover", icon: "mdi-delete-outline" },
        { nome: "Detalhes", icon: "mdi-information-outline" }
      ],
      dialog_acesso: false,
      dialog_remover: false,
      dialog_detalhes: false,
      loading_pasta: false,
      dialog_novo: false,
      dialog_detalhes_Pasta: false,
      dialog_embed: false,
      detalhes: [],
      arquivos: [],
      pastas: [],
      documentos_api: [],
      sub_pasta: [],
      URLpadrao: Api.getApUrl(),
      id_deletar: "",
      user_token: localStorage.getItem("user-token"),
      acessos_selecionados: [],
      loadingSaveAcessos: false,
      folder_file_selected: "",
      emails_selecionados: [],
      meus_documentos: false
    };
  },

  created() {
    this.getDocumentos();
    if (this.$router.currentRoute.path == "/meus_documentos") {
      this.meus_documentos = true;
    }
  },
  methods: {
    getAcessos(item) {
      this.clearArray();
      /* GRUPOS*/
      Api.get(`/meu_titulo/grupos?pasta=` + item.documento_pasta_hash)
        .then(response => {
          if (response.data) {
            this.select_acessos = response.data;
            this.folder_file_selected = item;
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].grupos[0].permissao == 1) {
                this.acessos_selecionados.push(response.data[i]);
              }
            }
          }
        })
        .catch(err => {
          this.$toast.error(err);
          throw err;
        });
      /*EMAILS*/
      Api.get(`/meu_titulo/emails?pasta=` + item.documento_pasta_hash)
        .then(response => {
          if (response.data) {
            this.folder_file_selected = item;
            for (var i = 0; i < response.data.length; i++) {
              this.emails_selecionados.push({
                email: response.data[i].email_usuario
              });
            }
          }
        })
        .catch(err => {
          this.$toast.error(err);
          throw err;
        });
    },
    embed(item) {
      const url =
        Api.getApUrl() +
        `/meu_titulo/show?documento_pasta_hash=` +
        item.documento_pasta_hash;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", item.documento_pasta_nome);
      document.body.appendChild(link);
      link.click();
    },
    voltar() {
      this.sub_pasta.pop();
      this.entrar_pasta(this.sub_pasta[this.sub_pasta.length - 1]);
    },
    entrar_pasta(item) {
      this.loading_pasta = true;
      if (item == undefined) {
        this.getDocumentos();
        return;
      }
      Api.get(`/meu_titulo/listaPasta?pasta_raiz=` + item.id_documento_pasta)
        .then(response => {
          if (response.data) {
            setTimeout(() => {
              if (!this.sub_pasta.includes(item)) {
                this.sub_pasta.push(item);
              }
              this.documentos_api = response.data;
              this.loading_pasta = false;

              this.filtro_pasta_arquivo();
            }, 500);
          }
        })
        .catch(err => {
          this.$toast.error(err);
          this.loading_pasta = false;

          throw err;
        });
    },
    deleteItem() {
      this.loading_pasta = true;

      let delete_json = {
        pasta: this.id_deletar
      };
      Api.post(`/meu_titulo/deletar`, delete_json)
        .then(response => {
          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            if (this.sub_pasta) {
              this.entrar_pasta(this.sub_pasta[this.sub_pasta.length - 1]);
            } else {
              this.getDocumentos();
            }
            this.loading_pasta = false;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.loading_pasta = false;

          throw err;
        });
      this.dialog_remover = false;
      this.id_deletar = "";
    },
    getDocumentos() {
      this.loading_pasta = true;
      Api.get(`/meu_titulo/listaPasta`)
        .then(response => {
          if (response.data) {
            setTimeout(() => {
              this.documentos_api = response.data;
              this.sub_pasta = [];
              this.pasta_id = "";
              this.pasta_nome = "";
              this.filtro_pasta_arquivo();
              this.loading_pasta = false;
            }, 500);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.errors);
          this.loading_pasta = false;

          throw err;
        });
    },
    reset() {
      this.novo_documento = {
        documentos: [],
        pasta_raiz: null
      };

      this.nova_pasta1 = {
        documento_pasta_nome: "",
        pasta_raiz: null
      };
    },
    sendPasta() {
      this.loading_doc = true;
      if (this.sub_pasta.length > 0) {
        this.nova_pasta1.pasta_raiz = this.sub_pasta[
          this.sub_pasta.length - 1
        ].id_documento_pasta;
        Api.post(`/meu_titulo/pasta`, this.nova_pasta1)
          .then(response => {
            setTimeout(() => {
              if (response.data) {
                this.$toast.success("Pasta criada com sucesso!");
                this.entrar_pasta(this.sub_pasta[this.sub_pasta.length - 1]);
              }
              this.loading_doc = false;
              this.reset();
            }, 500);
          })
          .catch(err => {
            this.$toast.error(err.response.errors);
            this.reset();
            this.loading_doc = false;
            throw err;
          });
      } else {
        Api.post(`/meu_titulo/pasta`, this.nova_pasta1)
          .then(response => {
            if (response.data) {
              setTimeout(() => {
                this.$toast.success("Pasta criada com sucesso!");
                this.loading_doc = false;

                this.getDocumentos();
                this.reset();
              }, 500);
            }
          })
          .catch(err => {
            this.$toast.error(err.response.errors);
            this.reset();
            this.loading_doc = false;
            throw err;
          });
      }
      this.reset_novo();
    },
    sendArquivo() {
      this.loading_doc = true;

      if (this.sub_pasta.length > 0) {
        this.novo_documento.pasta_raiz = this.sub_pasta[
          this.sub_pasta.length - 1
        ].id_documento_pasta;

        let formData = new FormData();
        Object.keys(this.novo_documento).map(key => {
          if (key === "documentos") {
            for (let i = 0; i < this.novo_documento.documentos.length; i++) {
              let file = this.novo_documento.documentos[i];
              if (this.novo_documento.documentos[i].name) {
                formData.append(`documentos[]`, file);
              }
            }
          } else {
            if (this.novo_documento[key]) {
              formData.append(key, this.novo_documento[key]);
            }
          }
        });
        Api.post(`/meu_titulo/pasta`, formData)
          .then(response => {
            if (response.data) {
              setTimeout(() => {
                this.$toast.success("Arquivo criado com sucesso!");
                this.loading_doc = false;
                this.reset();
                this.entrar_pasta(this.sub_pasta[this.sub_pasta.length - 1]);
              }, 500);
            }
          })
          .catch(err => {
            this.$toast.error(err.response.errors);
            this.loading_pasta = false;
            this.reset();
            this.loading_doc = false;
            throw err;
          });
      } else {
        let formData = new FormData();
        Object.keys(this.novo_documento).map(key => {
          if (key === "documentos") {
            for (let i = 0; i < this.novo_documento.documentos.length; i++) {
              let file = this.novo_documento.documentos[i];
              if (this.novo_documento.documentos[i].name) {
                formData.append(`documentos[]`, file);
              }
            }
          } else {
            if (this.novo_documento[key]) {
              formData.append(key, this.novo_documento[key]);
            }
          }
        });
        Api.post(`/meu_titulo/pasta`, formData)
          .then(response => {
            if (response.data) {
              setTimeout(() => {
                this.$toast.success("Arquivo criado com sucesso!");
                this.reset();
                this.loading_doc = false;
                this.getDocumentos();
              }, 500);
            }
          })
          .catch(err => {
            this.$toast.error(err.response.errors);
            this.reset();
            this.loading_doc = false;
            throw err;
          });
      }
      this.reset_novo();
    },
    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },
    reset_novo() {
      this.dialog_novo = false;
      this.nova_pasta = false;
      this.novo_arquivo = false;
    },
    filtro_pasta_arquivo() {
      this.pastas = [];
      this.arquivos = [];
      for (let i = 0; i < this.documentos_api.length; i++) {
        if (this.documentos_api[i].arquivo == 0) {
          this.pastas.push(this.documentos_api[i]);
        } else if (this.documentos_api[i].arquivo == 1) {
          this.arquivos.push(this.documentos_api[i]);
        }
      }
    },

    save() {
      this.push_acesso();
      this.close();
    },
    close() {
      this.dialog_acesso = false;
      this.dialog_remover = false;
      this.dialog_detalhes = false;
      this.permissao = [];
      this.email = [];
      this.clearArray();
    },
    clearArray() {
      this.select_acessos = [];
      this.acessos_selecionados = [];
      this.emails_selecionados = [];
      this.dialog_acesso = false;
      this.folder_file_selected = "";
    },
    menu(opcao, item) {
      if (opcao === "Alterar acessos") {
        this.getAcessos(item);
        this.dialog_acesso = true;
      } else if (opcao === "Remover") {
        this.id_deletar = item.id_documento_pasta;
        this.dialog_remover = true;
      } else if (opcao === "Detalhes") {
        this.detalhes = item;
        if (item.arquivo == 0) {
          this.dialog_detalhes_Pasta = true;
        } else {
          this.dialog_detalhes = true;
        }
      }
    },

    changeAcessos() {
      for (var i = 0; i < this.acessos_selecionados.length; i++) {
        for (var a = 0; a < this.acessos_selecionados[i].grupos.length; a++) {
          this.acessos_selecionados[i].grupos[a].permissao = 1;
        }
      }
    },

    saveAcessos() {
      this.loadingSaveAcessos = true;
      var dados = {
        permissoes: JSON.stringify(this.acessos_selecionados),
        emails: JSON.stringify(this.emails_selecionados),
        pasta: this.folder_file_selected.documento_pasta_hash
      };
      Api.post(`/meu_titulo/grupos-permitir`, dados)
        .then(response => {
          if (response.data) {
            this.loadingSaveAcessos = false;
            this.$toast.success("Permissões atualizadas!");
            this.dialog_acesso = false;
            this.clearArray();
          }
        })
        .catch(err => {
          this.$toast.error(err.errors);
          this.loadingSaveAcessos = false;
          throw err;
        });
    },

    addEmail(email) {
      this.emails_selecionados.push({ email: email });
      this.email = "";
    }
  }
};
</script>

<style>
</style>